import React from 'react';
import HreflangData from './hreflang';
import { Helmet } from 'react-helmet';
import { getDefaultCountryValues } from 'spwa-ui-library/esm/utils/helper';

const Hreflang = ({ page, categoryPage, category, categoryId }) => {
  const brand = process.env['REACT_APP_BRAND'] || 'kfc';
  const selectDefaultValue = getDefaultCountryValues();
  const changeWindowLocationLang = (lang) => {
    let tmpPath = window.location.pathname?.split('/');
    tmpPath[1] = lang;
    tmpPath = tmpPath.join('/');
    return window.location.origin + tmpPath;
  };

  if (categoryPage && !HreflangData.category[category]) {
    return null;
  }
  return (
    <>
      {categoryPage ? (
        <Helmet>
          <link
            rel="alternate"
            href={
              window.location.origin +
              HreflangData.category[category][brand](categoryId)[
                selectDefaultValue.defaultLang?.toLowerCase()
              ]
            }
            hreflang="x-default"
          />
          <link
            rel="alternate"
            href={window.location.origin + HreflangData.category[category][brand](categoryId)?.en}
            hreflang="en"
          />
          <link
            rel="alternate"
            href={window.location.origin + HreflangData.category[category][brand](categoryId)?.ar}
            hreflang="ar"
          />
        </Helmet>
      ) : (
        <Helmet>
          <link
            rel="alternate"
            href={changeWindowLocationLang(selectDefaultValue.defaultLang?.toLowerCase())}
            hreflang="x-default"
          />
          <link rel="alternate" href={changeWindowLocationLang('en')} hreflang="en" />
          <link rel="alternate" href={changeWindowLocationLang('ar')} hreflang="ar" />
        </Helmet>
      )}
    </>
  );
};

export default Hreflang;
